import axiosInstance from '@/plugins/axios';

const BASE = '/api/admin/ai-models';

export const actions = {
    async fetchAll() {
        this.loading = true;
        this.error = null;
        try {
            const { data } = await axiosInstance.get(BASE);
            this.list = data.data ?? [];
            if (data.settings) this.settings = data.settings;
        } catch (error) {
            this.error = error?.response?.data?.message ?? error.message;
            throw error;
        } finally {
            this.loading = false;
        }
    },

    /**
     * Uploads (or replaces) one model. The server computes sha256 and size
     * and pushes the file to the Space; we only show progress.
     */
    async upload({ key, name, version, file }) {
        this.saving = true;
        this.uploadProgress = 0;
        this.error = null;
        try {
            const form = new FormData();
            form.append('key', key);
            form.append('version', String(version));
            if (name) form.append('name', name);
            form.append('file', file);
            const { data } = await axiosInstance.post(BASE, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 0,
                onUploadProgress: (e) => {
                    if (e.total) this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                },
            });
            await this.fetchAll();
            return data;
        } catch (error) {
            this.error = error?.response?.data?.message ?? error.message;
            throw error;
        } finally {
            this.saving = false;
        }
    },

    async updateSettings(patch) {
        this.saving = true;
        try {
            const { data } = await axiosInstance.put(`${BASE}/settings`, { ...this.settings, ...patch });
            this.settings = data;
            return data;
        } finally {
            this.saving = false;
        }
    },

    async setPublished(key, isPublished) {
        await axiosInstance.patch(`${BASE}/${key}/publish`, { is_published: isPublished });
        const row = this.list.find((m) => m.key === key);
        if (row) row.is_published = isPublished;
    },
};
